import { graphql } from "@lululemon/dsp-shared";
import { IStoreDataProps } from "@lululemon/dsp-store-details/src/types/stores-types";
import {
  jotaiStore,
  storeCacheAtom,
  StoreCacheEntry
} from "@lululemon/dsp-jotai";
import { storesCacheLifespan } from "../../../config/cache";
import { storeQuery } from "../../../queries/store";

/**
 * fetches a store by a given slug
 * @param {string} slug
 * @param {*} req
 * @param {*} res
 * @returns {Promise<IStoreDataProps | null>}
 */
const fetchStoreBySlug = async (
  slug: string,
  req: any,
  res: any
): Promise<IStoreDataProps | null> => {
  if (!slug) {
    return null;
  }

  const cache: Map<string, StoreCacheEntry> = jotaiStore.get(storeCacheAtom);
  const now: number = Date.now();

  if (cache.has(slug)) {
    const { store, timestamp }: StoreCacheEntry = cache.get(slug);

    if (store && !(now - timestamp > storesCacheLifespan)) {
      return store;
    }
    cache.delete(slug);
  }

  const getSecret: Function = req?.app?.locals?.getSecret;
  const params: object = {
    query: storeQuery,
    variables: {
      slug
    },
    // the below values dont seem to be required to make this request.
    // or they do, and a server sided response is rendered after.
    req,
    res,
    getSecret
  };

  const store: IStoreDataProps = await graphql(params);

  cache.set(slug, { store, timestamp: now });
  jotaiStore.set(storeCacheAtom, cache);

  return store;
};

export default fetchStoreBySlug;
